(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["unity-contact-band"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', (event) => {
  const link = event.target.closest('[data-unity-chat-open]');
  if (!link) return;
  const chat = document.querySelector('shopify-chat');
  const runtime = chat?.shadowRoot?.querySelector('shopify-agent-runtime');
  const activator = runtime?.shadowRoot?.querySelector('button[part="activator"]');
  if (!activator) return;
  event.preventDefault();
  event.stopImmediatePropagation();
  if (activator.getAttribute('aria-expanded') !== 'true') activator.click();
}, true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["unity-services"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('unity-services-strip')) {
  customElements.define('unity-services-strip', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.grid = this.querySelector('.unity-service-band__grid');
      this.items = Array.from(this.querySelectorAll('.unity-service-band__item'));
      this.prev = this.querySelector('.unity-service-band__arrow--prev');
      this.next = this.querySelector('.unity-service-band__arrow--next');
      const current = () => Math.round(this.grid.scrollLeft / (this.grid.clientWidth || 1));
      const destination = (step) => (current() + step + this.items.length) % this.items.length;
      const update = () => {
        this.prev.setAttribute('aria-label', this.items[destination(-1)].innerText.trim());
        this.next.setAttribute('aria-label', this.items[destination(1)].innerText.trim());
      };
      const move = (step) => {
        this.grid.scrollTo({left: destination(step) * this.grid.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      };
      this.prev.addEventListener('click', () => move(-1));
      this.next.addEventListener('click', () => move(1));
      this.grid.addEventListener('scroll', update, {passive:true});
      let startX = 0;
      let startY = 0;
      let dragged = false;
      this.grid.addEventListener('pointerdown', (event) => {
        startX = event.clientX;
        startY = event.clientY;
        dragged = false;
      }, {passive:true});
      this.grid.addEventListener('pointermove', (event) => {
        if (Math.abs(event.clientX - startX) > 10 || Math.abs(event.clientY - startY) > 10) dragged = true;
      }, {passive:true});
      this.grid.addEventListener('click', (event) => {
        if (dragged && event.detail !== 0) event.preventDefault();
        dragged = false;
      });
      this.dataset.ready = 'true';
      update();
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
